import React from 'react'
import styled from 'styled-components'
import Logo from '../../molecules/share/Logo'

// import { PrimaryButton } from 'smarthr-ui'
// <PrimaryButton>Hello World</PrimaryButton>

export const Footer = () => {
  return (
    <FooterArea>
      <LogoArea>
        <Logo />
      </LogoArea>
    </FooterArea>
  )
}

const FooterArea = styled.footer`
  height: 3rem;
  background-color:  rgba(150,152,154, 0.2);
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
`
const LogoArea = styled.div`
  width: 60%;
  display: flex;
`
const CompanyArea = styled.div`
  width: 40%;
  display: flex;
  justify-content: right;
  margin: auto 0;
  padding-right: 5rem;
`
const Middle = styled.a`
`
const Img = styled.img`
  width: 10rem;
`

export default Footer
